import { Header } from './Header';
import { Footer } from './Footer';
import { InquiryListDrawer } from './InquiryListDrawer';
import { Toaster } from '@/components/ui/sonner';

export function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        {children}
      </main>
      <Footer />
      <InquiryListDrawer />
      <Toaster position="bottom-right" />
    </div>
  );
}
